import { useEffect } from 'react';
import { useBorneStore } from '../store/borne-store';

const BG_MAP = {
  success: 'bg-success',
  error: 'bg-danger',
  warning: 'bg-warning',
} as const;

export function Toast() {
  const toastMessage = useBorneStore((s) => s.toastMessage);
  const hideToast = useBorneStore((s) => s.hideToast);

  useEffect(() => {
    if (!toastMessage) return;

    const timer = setTimeout(() => {
      hideToast();
    }, 3000);

    return () => clearTimeout(timer);
  }, [toastMessage, hideToast]);

  if (!toastMessage) return null;

  const bgClass = BG_MAP[toastMessage.type];

  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[60] animate-fade-in">
      <div className={`${bgClass} rounded-xl px-6 py-3 shadow-lg`}>
        <p className="text-white text-lg font-semibold text-center">
          {toastMessage.text}
        </p>
      </div>
    </div>
  );
}
